export const INBOX_TYPES = {
  WEB: 'Channel::WebWidget',
  FB: 'Channel::FacebookPage',
  TWITTER: 'Channel::TwitterProfile',
  TWILIO: 'Channel::TwilioSms',
  WHATSAPP: 'Channel::Whatsapp',
  // TWILIO: 'Channel::TwilioSms',
  SIGNALWIRE: 'Channel::SignalwireLink',
  API: 'Channel::Api',
  EMAIL: 'Channel::Email',
  TEAM_CHAT: 'Channel::TeamChat',
  REVIEW: 'Channel::FacebookReview',
  GOOGLE_REVIEW: 'Channel::GoogleReview',
  TELEGRAM: 'Channel::Telegram',
  LINE: 'Channel::Line',
  YOUTUBE: 'Channel::Youtube',
  LEAD: 'Channel::Lead',
};

export default {
  computed: {
    channelType() {
      return this.inbox.channel_type;
    },
    isALeadInbox() {
      return this.channelType === INBOX_TYPES.LEAD;
    },
    isAPIInbox() {
      return this.channelType === INBOX_TYPES.API;
    },
    isATwitterInbox() {
      return this.channelType === INBOX_TYPES.TWITTER;
    },
    isAFacebookInbox() {
      return this.channelType === INBOX_TYPES.FB;
    },
    isAWebWidgetInbox() {
      return this.channelType === INBOX_TYPES.WEB;
    },
    isATwilioChannel() {
      return this.channelType === INBOX_TYPES.TWILIO;
    },
    isALineChannel() {
      return this.channelType === INBOX_TYPES.LINE;
    },
    isAnEmailChannel() {
      return this.channelType === INBOX_TYPES.EMAIL;
    },
    isATeamChatChannel() {
      return this.channelType === INBOX_TYPES.TEAM_CHAT;
    },
    isATelegramChannel() {
      return this.channelType === INBOX_TYPES.TELEGRAM;
    },
    isSignalwireChannel() {
      return this.channelType === INBOX_TYPES.SIGNALWIRE;
    },
    isATwilioWhatsappChannel() {
      const { medium: medium = '' } = this.inbox;
      return this.isATwilioChannel && medium === 'whatsapp';
    },
    chatAdditionalAttributes() {
      const { additional_attributes: additionalAttributes } = this.chat || {};
      return additionalAttributes || {};
    },
    isTwitterInboxTweet() {
      return this.chatAdditionalAttributes.type === 'tweet';
    },
    twilioBadge() {
      return `${this.isATwilioSMSChannel ? 'sms' : 'whatsapp'}`;
    },
    twitterBadge() {
      return `${this.isTwitterInboxTweet ? 'twitter-tweet' : 'twitter-dm'}`;
    },
    facebookBadge() {
      return this.chatAdditionalAttributes.type || 'facebook';
    },
    inboxBadge() {
      let badgeKey = '';
      if (this.isATwitterInbox) {
        badgeKey = this.twitterBadge;
      } else if (this.isAFacebookInbox) {
        badgeKey = this.facebookBadge;
      } else if (this.isATwilioChannel) {
        badgeKey = this.twilioBadge;
      } else if (this.isAWhatsappChannel) {
        badgeKey = 'whatsapp';
      } else if (this.isAYoutubeChannel) {
        badgeKey = 'youtube';
      }
      return badgeKey || this.channelType;
    },
    isAWhatsappChannel() {
      return (
        this.channelType === INBOX_TYPES.WHATSAPP ||
        this.isATwilioWhatsappChannel
      );
    },
    isReviewChannel() {
      return this.channelType === INBOX_TYPES.REVIEW;
    },
    isGoogleReviewChannel() {
      return this.channelType === INBOX_TYPES.GOOGLE_REVIEW;
    },
    isAYoutubeChannel() {
      return this.channelType === INBOX_TYPES.YOUTUBE;
    },
  },
};
